exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@keyframes moon-loading-indicator-rotate{to{transform:rotate(1turn)}}.moon-loading-indicator,.moon-loading-indicator .moon-ball-style{border-radius:100%}.moon-loading-indicator .moon-ball-background{border-color:#1e88e5;border-style:solid;opacity:.1}.moon-loading-indicator .moon-ball{background-color:#1e88e5;opacity:.8;position:absolute}.moon-loading-indicator .moon-ball-animation{animation:moon-loading-indicator-rotate 1s 0s infinite linear;animation-fill-mode:forwards}", ""]);

// exports
